import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { Plan } from '@/models/plan';

export const fetchPlan = async (name: string): Promise<Plan | null> => {
  const response = await queryExecute({
    query: graphql(`
      query Plan($name: String!) {
        plan(name: $name) {
          id
          name
          description
          callerDescription
          kind
          amount
          isActive
          isAlwaysOperator
          hasTrial
          trialPrice
          trialPlanName
          tier
          billingCyclePeriodNum
          billingCyclePeriodType
          prioritySupport
          data
          activeHours
          authorizedGuestTrips
          dashboard
          deprecated
          emergencyCalls
          favoriteOperators
          freeGroceries
          freeRides
          goGoCare
          gourmetPaymentTier
          groceryPaymentTier
          groceryStandingOrder
          hasTrial
          homeServices
          insuranceAndTaxStatements
          isAllowedPartnerCaller
          isAllowedRegularCaller
          isAlwaysOperator
          isFreePlan
          isFreePrintedInvoice
          isHighAlerts
          leisureTrips
          lovedOnesLimit
          minAllowedRole
          operatorOrderedRidePrice
          pharmacyPaymentTier
          proactiveCareManagement
          ridePaymentTier
          specialRequestPaymentTier
          splitPayments
          turningOffReceipts
          wellnessChecks
          isDefault
          fragmentInto
          defragmentInto
          upgradeInto
          createdAt
          updatedAt
        }
      }
    `),
    variables: {
      name,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.plan ?? null;
};
